import { useState } from "react";
import { Copy, Check } from "lucide-react";

export default function CodeBlock({ lang = "bash", code }) {
  const [copied, setCopied] = useState(false);
  const onCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="code-block my-3" data-testid="code-block">
      <div className="code-bar">
        <span className="font-mono">{lang}</span>
        <button
          onClick={onCopy}
          className="flex items-center gap-1 hover:text-[var(--gold)] transition"
          data-testid="code-copy-btn"
        >
          {copied ? <Check size={13}/> : <Copy size={13}/>}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <pre><code className="font-mono">{code}</code></pre>
    </div>
  );
}
